import store from '@/study-search/store';
import { Deployment } from '@/study-search/utils/Deployment';
import { PortalType } from '@studyportals/domain-client';
import { CountryTier } from '@studyportals/iu-global-access-initiative/definitions/CountryTier';
import { SearchStudyCardInfo } from '@/study-search/domain';

class IUVisibilityHelper {
	private readonly eligibleOrganisationIds = [421, 21012, 21013];

	public eligiblePortalType(portalType: PortalType): boolean {
		return (
			portalType === PortalType.MASTER ||
			portalType === PortalType.BACHELOR ||
			portalType === PortalType.DISTANCE_LEARNING
		);
	}

	public canShowIUDiscountInfo(portalType: PortalType, searchResult: SearchStudyCardInfo): boolean {
		return (
			this.belongsToPartnership(searchResult, this.eligibleOrganisationIds) &&
			this.eligiblePortalType(portalType) &&
			Deployment.hasDomainApiGetEctsMember(searchResult.card)
		);
	}

	public canShowIUIncentive(
		countryTier: CountryTier,
		portalType: PortalType,
		searchResult: SearchStudyCardInfo
	): boolean {
		return (
			this.canShowIUDiscountInfo(portalType, searchResult) &&
			(countryTier !== CountryTier.INELIGIBLE || !store.getters.isGAIQuestionnaireTaken())
		);
	}

	private belongsToPartnership(searchResult: SearchStudyCardInfo, organisationIds: number[]): boolean {
		return organisationIds.includes(searchResult.card.getUniversityId());
	}
}

export default new IUVisibilityHelper();
